import { debug, hoc, utils } from 'lib';
import { UiToast } from 'components';
import service from './service';

import PopupEntry from './popup-entry';
import PopupHistory from './popup-history';
import { oathStore } from './store';

const log = debug.create('oath.socket');

const handle = (socket) => {
  // 赠送祝福发送弹幕
  // action: oath-danmu
  // {
  // text: (弹幕文案)
  // }
  socket.on('oath-danmu', (msg) => {
    oathStore.pushItem(msg.data.text);
  });

  // 直播间入场消息
  // {
  // userNickname: (用户昵称)
  // userPic: (用户头像)
  // starNickname: (主播昵称)
  // starPic: (主播头像)
  // second: (显示多少秒)
  // timestamp: (时间戳)
  // }
  socket.on('oath-entry', (msg) => {
    hoc.render(
      {
        key: 'oathEntry',
        data: msg.data,
        title: '欢迎加入仪式观礼',
        desc: '仪式即将开始',
      },
      PopupEntry,
    );
  });

  // 海誓山盟协议
  // {
  // userNickname: (用户昵称)
  // userPic: (用户头像)
  // starNickname: (主播昵称)
  // starPic: (主播头像)
  // second: (显示多少秒)
  // timestamp: (时间戳)
  // }
  socket.on('oath-agreement', (msg) => {
    hoc.render(
      {
        key: 'oathEntry',
        data: msg.data,
        title: '海誓山盟',
        desc: '请签订契约伴侣协议',
      },
      PopupEntry,
    );
  });

  //   结伴共赴旅行
  // action: oath-travel
  // {
  // userNickname: (用户昵称)
  // userPic: (用户头像)
  // starNickname: (主播昵称)
  // starPic: (主播头像)
  // second: (显示多少秒)
  // timestamp: (时间戳)
  // }

  socket.on('oath-travel', (msg) => {
    hoc.render(
      {
        key: 'oathEntry',
        data: msg.data,
        title: '结伴旅行',
        desc: '誓约双方即将结伴共赴旅行',
      },
      PopupEntry,
    );
  });
  //   仪式纪念，收到此消息调用纪念册列表接口
  // action: oath-rite
  // {
  // }

  socket.on('oath-rite', (msg) => {
    hoc.render(
      {
        key: 'oathEntry',
      },
      PopupHistory,
    );
  });
  // 播放动效
  // action: oath-effect
  // {
  // round: (第几号动效)
  // timestamp: (时间戳)
  // }

  socket.on('oath-effect', (msg) => {
    oathStore.setEffect(msg.data);
  });
};

export default handle;
